<script setup lang="ts">
import LogoFull from '@/assets/images/logo-text.svg'
import LogoMark from '@/assets/images/logo.svg'
</script>

<template>
  <section class="min-h-dvh min-w-90 relative flex flex-col justify-center bg-background">
    <div class="flex flex-col items-center justify-center gap-14 z-10">
      <LogoFull class="h-12 w-auto text-primary" />
      <slot />
    </div>
    <LogoMark class="pointer-events-none absolute -bottom-12 -right-16 h-85 w-auto text-accent" />
  </section>
</template>
